<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog(3)"
      selectShowPower="/bonusplan/select"
      addShowPower="/bonusplan/add"
      buttonName="分红计算"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/bonusplan/qpayInfoQry"
      @down="down"
      :totalShow="true"
      totalShowType="warning"
      totalName="导出"
      totaltext="/bonusplan/export"
      @totalLookDialog="totalLookDialog"
      :batchShow="true"
      batchpass="/bonusplan/batch"
      batchName="批量审核"
      @batchLookDialog="openAddDialog(4)"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商姓名">
        <el-input v-model="formModel.userName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input v-model="formModel.phone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="业务类型" prop="operation">
        <el-select v-model="formModel.operation">
          <el-option
            v-for="item in operation"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分红年月">
        <el-date-picker
          v-model="formModel.month"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleSelectionChange="handleSelectionChange"
      @handleChange="getPage"
    >
      <el-table-column
        type="selection"
        :selectable="checkboxT"
        disabled="true"
        width="60"
        margin-left="5px"
      >
      </el-table-column>
      <el-table-column
        prop="userId"
        label="代理商ID"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="代理商姓名"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="代理商手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="业务类型"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="month"
        label="分红月份"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranAmt"
        label="金额(元)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableDataStatus"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/bonusplan/sh') || hasPerm('/bonusplan/bj')"
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div style="margin-right: 10px" v-if="hasPerm('/bonusplan/bj')">
              <el-button
                type="text"
                v-if="scope.row.status == 0"
                @click="openAddDialog(2, scope.row)"
                >编辑
              </el-button>
              <el-button type="text" disabled v-else>编辑</el-button>
            </div>
            <div
              style="margin-left: 10px; margin-right: 20px"
              v-if="hasPerm('/bonusplan/sh')"
            >
              <el-button
                type="text"
                v-if="scope.row.status == 0"
                @click="openAddDialog(1, scope.row)"
                >审核
              </el-button>
              <el-button type="text" disabled v-else>已审核</el-button>
            </div>
            <el-button type="text" @click="handleDelete(scope.row)"
              >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="
        flag == 1
          ? '审核'
          : flag == 2
          ? '编辑'
          : flag == 3
          ? '分红计算'
          : flag == 4
          ? '批量审核'
          : ''
      "
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
    >
      <div v-if="flag == 1 || flag == 4">
        <el-form-item label="批量勾选条数" v-if="flag == 4">
          {{ ids.length }}
        </el-form-item>
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="dialogModel.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="dialogModel.remark"
            maxlength="200"
            show-word-limit
            type="textarea"
            rows="3"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </div>
      <div v-else-if="flag == 2">
        <el-form-item label="代理商ID">
          <el-input
            v-model="dialogModel.userId"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商姓名">
          <el-input
            v-model="dialogModel.userName"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商手机号">
          <el-input
            v-model="dialogModel.phone"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务类型">
          <el-input
            v-model="dialogModel.operation"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="分红月份">
          <el-input
            v-model="dialogModel.month"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="分红金额">
          <el-input-number
            style="width: 244px"
            v-model="dialogModel.tranAmt"
            :min="0"
            :max="999999999"
            :step="0.1"
            :precision="2"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
      </div>
      <div v-else-if="flag == 3">
        <el-form-item label="月份">
          <el-select v-model="dialogModel.month" clearable>
            <el-option
              v-for="item in month"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </form-dialog>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>金额：{{ dialogAmount }}元</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import FinanceService from "service/FinanceService";
import StatisticsService from "service/StatisticsService";

import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "bonusplan",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      dialogAmount: 0,
      show: false,
      formModel: {
        userId: "",
        phone: "",
        userName: "",
        status: "",
        month: "",
      },
      tableData: [],
      multipleSelection: [],
      ids: [],
      submitService: FinanceService.bonusplanList,
      itemId: "",
      dialogModel: {
        status: 1, //审核
        remark: "",

        tranAmt: "", //编辑

        month: "", //分红计算
      },
      operation: [
        {
          id: "",
          name: "全部",
        },
      ],
      status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "0",
          value: "待审核",
        },
        {
          id: "1",
          value: "通过",
        },
        {
          id: "2",
          value: "驳回",
        },
      ],
      month: [
        {
          id: "1",
          value: "一月",
        },
        {
          id: "2",
          value: "二月",
        },
        {
          id: "3",
          value: "三月",
        },
        {
          id: "4",
          value: "四月",
        },
        {
          id: "5",
          value: "五月",
        },
        {
          id: "6",
          value: "六月",
        },
        {
          id: "7",
          value: "七月",
        },
        {
          id: "8",
          value: "八月",
        },
        {
          id: "9",
          value: "九月",
        },
        {
          id: "10",
          value: "十月",
        },
        {
          id: "11",
          value: "十一月",
        },
        {
          id: "12",
          value: "十二月",
        },
      ],
      dialogRules: {
        status: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      page: {},
      isPage: false,
      isFlag: false,
      flag: "",
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        userId: this.formModel.userId,
        userName: this.formModel.userName,
        phone: this.formModel.phone,
        operation: this.formModel.operation,
        status: this.formModel.status,
        month: this.formModel.month,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      if (this.flag == 1) {
        const params = {
          status: this.dialogModel.status,
          remark: this.dialogModel.remark,
        };
        if (this.itemId) {
          params.id = this.itemId;
        }
        // console.log("审核", params, this.flag, this.itemId);
        return params;
      } else if (this.flag == 2) {
        const params = {
          tranAmt: this.dialogModel.tranAmt,
        };
        if (this.itemId) {
          params.id = this.itemId;
        }
        // console.log("编辑", params, params, this.flag, this.itemId);
        return params;
      } else if (this.flag == 3) {
        const params = {
          month: this.dialogModel.month,
        };
        // console.log("分红计算", params, this.flag, this.itemId);
        return params;
      } else if (this.flag == 4) {
        const params = {
          status: this.dialogModel.status,
          remark: this.dialogModel.remark,
          ids: this.ids,
        };
        // console.log("批量审核", params, this.flag);
        return params;
      }
    },
    dialogService() {
      if (this.flag == 1) {
        return FinanceService.bonusplanSh;
      } else if (this.flag == 2) {
        return FinanceService.bonusplanEdit;
      } else if (this.flag == 3) {
        return FinanceService.bonusplanFhjs;
      } else if (this.flag == 4) {
        return FinanceService.bonusplanPlSh;
      }
      //   return this.itemId
      //     ? FinanceService.bonusplanSh
      //     : FinanceService.bonusplanEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        date: "",
        status: "",
        operation: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getbusitype();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    checkboxT(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      str = str.substring(0, str.length - 1);
      this.ids = str.split(",");
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        FinanceService.bonusplanDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(flag, item) {
      this.flag = flag;
      this.itemId = item ? item.id : "";
      console.log(this.ids);
      if (this.flag == 2) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.$refs.formDialog.open();
      }
      if (flag == 1 || flag == 3) {
        this.$refs.formDialog.open();
      }
      if ((flag == 4 && this.ids.length == 0) || this.ids[0] == "") {
        this.$message({
          message: "批量审核数据为0条,请批量勾选数据",
          type: "warning",
        });
      } else {
        this.$refs.formDialog.open();
      }
    },

    dialogClose() {
      this.dialogModel = {
        status: 1,
        remark: "",

        tranAmt: "", //编辑

        month: "", //分红计算
      };
      this.itemId = "";
      this.flag = "";
      this.ids = [];
      this.multipleSelection = [];
      //   console.log(
      //     "itemId",
      //     this.itemId,
      //     "flag",
      //     this.flag,
      //     "数据",
      //     this.dialogModel
      //   );
      this.$refs.commonTable.clearSelection();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res;
        this.tableData = result.contents.rows;
        this.page.currentPage = result.contents.current;
        this.page.total = result.contents.total;
        this.page.pageSize = result.contents.size;
      });
    },
    down() {
      this.doLoad(
        FinanceService.bonusplanHj,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogAmount = 0;
            if (result) {
              this.dialogAmount = result;
            }
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    totalLookDialog() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8885",
            "/shareplan/t-share-plan/"
          )
        : "";
    },
    getbusitype() {
      this.doLoad(
        FinanceService.busitype,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.operation = [...this.operation, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    formatterTableDataStatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/BonusPlan.vue